import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";

const styles = (theme) => ({
  proDetailsHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
  proDetails: {
    fontSize: 10,
    color: theme.TextColor,
    opacity: 0.6,
    letterSpacing: 1.5,
  },
  showDetails: {
    fontSize: 10,
    color: theme.TextColor,
    opacity: 0.6,
  },
  proNumber: {
    color: theme.proNumberColor,
    fontSize: theme.headerTextFontSize,
    marginTop: 0,
  },
  deliveryStatus: {
    background: theme.activeRadioBG,
    padding: "4px 8px 4px 8px",
    borderRadius: "10px",
    fontSize: 8,
    color: theme.successTextColor,
    marginLeft: 8,
    fontWeight: 600,
    textTransform: "uppercase",
    height: "fit-content"
  },
  proDetailsContainer: {
    display: "flex",
  },
});

const ShipmentDetailsHeader = ({
  handleExpandMoreClick,
  expanded,
  hideDetailsMenu,
  proId,
  deliveryStatus,
  classes,
}) => {
  return (
    <>
      <div className={classes.proDetailsHeader}>
        <p className={classes.proDetails}>PRO DETAILS</p>
        {!expanded && !hideDetailsMenu && (
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
            onClick={handleExpandMoreClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <span className={classes.showDetails}>Show Details</span>
            <ExpandMoreIcon className={classes.showDetails} />
          </IconButton>
        )}
      </div>
      <div className={classes.proDetailsContainer}>
        <p className={classes.proNumber}>{`PRO# ${proId}`}</p>
        {deliveryStatus && (
          <span className={classes.deliveryStatus}>{deliveryStatus}</span>
        )}
      </div>
    </>
  );
};

export default withStyles(styles)(ShipmentDetailsHeader);
